/**
 * @generated SignedSource<<1264d947c3090e4a384b3fe0d23272c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type platformSummaryQuery$variables = Record<PropertyKey, never>;
export type platformSummaryQuery$data = {
  readonly platformSummary: {
    readonly complimentarySubscriptions: number;
    readonly freeSubscriptions: number;
    readonly paidSubscriptions: number;
    readonly planBreakdown: ReadonlyArray<{
      readonly complimentaryCount: number;
      readonly planName: string;
      readonly subscriptionCount: number;
    }>;
    readonly totalAccounts: number;
    readonly totalVaults: number;
  };
};
export type platformSummaryQuery = {
  response: platformSummaryQuery$data;
  variables: platformSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PlatformSummary",
    "kind": "LinkedField",
    "name": "platformSummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalVaults",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAccounts",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "freeSubscriptions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paidSubscriptions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "complimentarySubscriptions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlanBreakdownItem",
        "kind": "LinkedField",
        "name": "planBreakdown",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "complimentaryCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "platformSummaryQuery",
    "selections": (v0/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "platformSummaryQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5704e8430fb657dc8a9a5ecce62bc9be",
    "id": null,
    "metadata": {},
    "name": "platformSummaryQuery",
    "operationKind": "query",
    "text": "query platformSummaryQuery {\n  platformSummary {\n    totalVaults\n    totalAccounts\n    freeSubscriptions\n    paidSubscriptions\n    complimentarySubscriptions\n    planBreakdown {\n      planName\n      subscriptionCount\n      complimentaryCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ecde1b1a89d8eafd46bfeb3e2e589a64";

export default node;
